<div
  class="sub-header"
>
  <div class="sub-header-row border-top align-items-center px-1">
    @if (this.view$ |async; as view) {
      @if (this.user$ | async; as user) {
        <div class="row">
          <div class="col">
            @if (this.userActions$ | async; as userActions) {
              @for (action of userActions; track action.name) {
                <a class="btn-sm btn btn-outline-primary"
                   (click)="triggerAction(action.name)"
                   translate
                >
                  {{ action.actionName }}
                </a>
              }
            }
            <!--              <a class="btn-sm btn btn-outline-primary"-->
            <!--                (click)="triggerAction('userUnlock')"-->
            <!--                translate-->
            <!--              >-->
            <!--                USER_LBL_UNLOCK / USER_LBL_LOCK-->
            <!--              </a>-->


          </div>

          <div class="col-auto state-breadcrumb-col">
            <div class="state-breadcrumb">
              @if (user.aspNetUserEmailConfirmed) {
                <li class="active-success">
                  <span translate>USER_LBL_STATUS_ACTIVE</span>
                </li>
              } @else {
                <li class="active-danger">
                  <span translate>USER_LBL_STATUS_INACTIVE</span>
                </li>
              }
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>
